import { memo } from 'react';

import { useCurrentUserClientTimezone } from '../../../../../../contexts/OidcContext/OidcContext.selectors';
import { TimeDisplay } from '../../../../../navigation/ToggleUTCLocal/TimeDisplays/TimeDisplay';
import { StyledDisplayDataBox } from './DisplayTurnaroundData.style';

export const DisplayCtotData = memo(function DisplayCtotData({ ctotTime }: { ctotTime?: number }) {
    const timezone = useCurrentUserClientTimezone();
    return (
        <StyledDisplayDataBox>
            {ctotTime ? (
                <>
                    <div>{'C'}</div>
                    &thinsp;
                    <TimeDisplay time={ctotTime} blink={false} timezone={timezone} undisplayedZone={true} />
                </>
            ) : (
                <div>-</div>
            )}
        </StyledDisplayDataBox>
    );
});
